import dayjs from "dayjs";

// Helper function to convert dayjs objects to ISO strings for backend storage
export const prepareDayjsFieldsForStorage = (formData: any) => {
    const preparedData = { ...formData };
    const dayjsFields = [
      'date_visite',
      'date_debut_commercialisation',
      'date_fin_commercialisation',
      'date_livraison'
    ];
  
    dayjsFields.forEach(field => {
      if (preparedData[field] && dayjs.isDayjs(preparedData[field])) {
        preparedData[field] = preparedData[field].toISOString();
      }
    });
  
    return preparedData;
  };
  
  // Helper function to convert ISO strings back to dayjs objects after retrieval
 export const restoreDayjsFields = (formData: any) => {
    const restoredData = { ...formData };
    const dayjsFields = [
      'date_visite',
      'date_debut_commercialisation',
      'date_fin_commercialisation',
      'date_livraison'
    ];
  
    dayjsFields.forEach(field => {
      if (restoredData[field]) {
        restoredData[field] = dayjs(restoredData[field]);
      }
    });
  
    return restoredData;
  };
  